import React, { useState } from "react";
import { toast } from "react-toastify";
import API from "../Network/API";
import PostCreateModal from "./Modal/PostCreateModal";
import UploadProgressStrip from "./UploadProgressStrip";
import { useTranslation } from "react-i18next";
import "./CreatePost.css";

export default function CreatePost() {
    const { t } = useTranslation();
    const fileObj = [];
    const fileArray = [];
    const fileArrayAnother = [];
    const fileArrayVideo = [];
    const [isLoading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);
    const [file, setFile] = useState([]);
    const [post_modalDialog, setPostShareModalDialog] = useState(false);
    const fileInput = React.useRef();

    const toggleModalSharePost = () => {
        setPostShareModalDialog(!post_modalDialog)
    };

    function onCreatePost() {
        if (selectedFile === null && message === null) {
            toast.error("Post is empty");
            return false;
        }
        const fd = new FormData();
        if (selectedFile != null) {
            let fileExtention = selectedFile.name.split('.').pop();
            if (fileExtention.toUpperCase() == "MP4" || fileExtention.toUpperCase() == "WMV" || fileExtention.toUpperCase() == "AVI" || fileExtention.toUpperCase() == "MKV" || fileExtention.toUpperCase() == "WEBM" || fileExtention.toUpperCase() == "MOV") {
                if (selectedFile) {
                    fd.append('video[]', selectedFile, selectedFile.name);
                }
            } else {
                if (file) {
                    for (var i = 0; i < file.length; i++) {
                        fd.append('image[]', file[i], file[i].name);
                    }
                }
            }
        }


        if (message != "") {
            fd.append('details', message);
        }
        setLoading(true)
        API.post("/posts", fd, {
            onUploadProgress: progressEvent => {
                // console.log("Progress: " + progressEvent.loaded / progressEvent.total);
            }
        })
            .then((response) => {
                setLoading(false)
                if (response.data.success === true) {
                    toast.success(response.data.message);
                    window.location = "/";
                } else if (response.data.success === false) {
                    //console.log(response.data.message);
                }
            })
            .catch((err) => {
                setLoading(false)
            });
    }

    const uploadHandler = (e) => {
        setSelectedFile(e.target.files[0]);
        setFileUrl(URL.createObjectURL(e.target.files[0]))
        fileObj.push(e.target.files)
        for (let i = 0; i < fileObj[0].length; i++) {
            let extn = e.target.files[i].name.split('.').pop();

            if (extn.toLowerCase() === 'mp4' || extn.toLowerCase() === 'wmv' || extn.toLowerCase() === 'avi' || extn.toUpperCase() === "MKV" || extn.toUpperCase() === "WEBM" || extn.toUpperCase() === "MOV") {
                fileArrayVideo.push(URL.createObjectURL(fileObj[0][i]));
            } else {
                fileArray.push(URL.createObjectURL(fileObj[0][i]))
            }
            fileArrayAnother.push(fileObj[0][i])
        }

        setFile(fileArrayAnother)

    }
    let msgText = t('Whats on your mind') + ", " + (localStorage.getItem("profile_name") || "") + "?";
    const onClick = () => {
        // fileInput.current.click();
        toggleModalSharePost();
    }
    const myArr = JSON.parse(localStorage.getItem('user_data')) || {};

    return (
        <>
            <div className="news-feed-area">
                <div className="create-post-card">
                    <div className="create-post-top">
                        <div className="create-post-avatar" style={{ backgroundImage: `url(${myArr.avatar || ''})` }} />
                        <button
                            type="button"
                            className="create-post-input"
                            onClick={onClick}
                        >
                            {msgText}
                        </button>
                    </div>
                    <hr className="create-post-divider" />
                    <div className="create-post-actions">
                        <button
                            type="button"
                            className="create-post-action create-post-action--video"
                            onClick={onClick}
                        >
                            <i className="fas fa-video" />
                            <span className="d-none d-sm-inline">{t('Video')}</span>
                        </button>
                        <button
                            type="button"
                            className="create-post-action create-post-action--photo"
                            onClick={onClick}
                        >
                            <i className="fas fa-image" />
                            <span className="d-none d-sm-inline">{t('Photo')}</span>
                        </button>
                        <button
                            type="button"
                            className="create-post-action create-post-action--room"
                            onClick={(e) => {
                                e.stopPropagation();
                                window.location.href = '/audio-rooms?action=create';
                            }}
                        >
                            <i className="fas fa-microphone" />
                            <span className="d-none d-sm-inline">{t('Room')}</span>
                        </button>
                    </div>
                </div>
            </div>
            <UploadProgressStrip />
            <PostCreateModal isModalVisible={post_modalDialog} handleShowB={() => setPostShareModalDialog(false)} />
        </>
    )
}